import { type FunctionComponent } from 'react';

import { Checkbox } from '@american-autonomy/ag-ui';

import SelectItem from 'components/SelectItem';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MultiSelectItem: FunctionComponent<Props> = ({
    className = '',
    item,
    itemsSelected,
    onClick,
    testId = TEST_ID
}) => {
    const isSelected = itemsSelected.some(selected => selected.value === item.value);

    return (
        <SelectItem
            className={className}
            isSelected={isSelected}
            item={item}
            onClick={onClick}
            testId={testId}>
            <Checkbox className={styles.checkbox} isChecked={isSelected} />
        </SelectItem>
    );
};

export default MultiSelectItem;
